'use strict';

exports.__esModule = true;
exports.allPracticesObject = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

var _bookAppointmentSection = require('../actions/book-appointment-section');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	activeView: 'calendar'
};

var allPracticesObject = exports.allPracticesObject = { id: null, name: 'All Practices' };

var bookAppointmentSection = function bookAppointmentSection(state, action) {
	switch (action.type) {
		case _pageActions.LOAD_SPECIALIST_PROFILE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				selectedPractice: allPracticesObject
			});
		case _bookAppointmentSection.TOGGLE_CALENDAR_VIEW:
			return (0, _assign2.default)({}, state, { activeView: action.view });
		case _bookAppointmentSection.UPDATE_CALENDAR_START_DATE:
			return (0, _assign2.default)({}, state, { calendarStartDate: action.startDate });
		case _bookAppointmentSection.PRACTICE_SELECTED:
			return (0, _assign2.default)({}, state, { selectedPractice: action.practice });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = bookAppointmentSection;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/reducers/book-appointment-section.js